import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { FiCalendar, FiMapPin } from "react-icons/fi";


function ClubAllEventCard({ id, club, collaborating_clubs, description, event_date, organizing_club, poster_image, registration_deadline, registration_link, title, venue }) {

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

  return (
    <div className='eventCard'>
        <div className='event_img'>
            <img src={poster_image} alt='' onClick={handleClickOpen}/>
        </div>
        <Dialog open={open} onClose={handleClose}>
            <DialogContent>
                <div className='eventCard_img_modal'>
                    <img src={poster_image} alt='' />
                </div>
            </DialogContent>
        </Dialog>
        <div className='event_details'>
            <div className='event_title'>
                <h1>{title}</h1>
                <Link to={`${id && id}/update`}>
                    <button className='event_edit_btn'>Edit</button>
                </Link>
                
            </div>
            <div className='event_info'>
                <div className='event__content'>
                    <FiCalendar className='event_info_icon'/>
                    <h3>{event_date}</h3>
                </div>
                <div className='event__content'>
                    <FiMapPin className='event_info_icon'/>
                    <h3>{venue}</h3>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ClubAllEventCard